import deriveLinkComponents from '../associations/derive-link-components';
import api from '../REST/api';
import AgreementLink from './AgreementLink';

const { Link, Links } = deriveLinkComponents(AgreementLink, api.getAgreement);

export { Link as AgreementLink, Links as AgreementLinks };
